import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const forgeServicedeskQueueRoute: InvariantJiraRoute = {
	name: 'forge-spa-servicedesk-queue',
	path: '/jira/servicedesk/projects/:projectKey/queues/apps/:appId/:envId/:route?',
};
